import React, { useState } from "react";
import { FaArrowAltCircleUp } from "react-icons/fa";

const ButtonScrollTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);
  return (
    <div className="container-btn-scroll-top">
      <button
        className="btn btn-scroll-top"
        onClick={scrollToTop}
        style={{ display: visible ? "flex" : "none" }}
      >
        <FaArrowAltCircleUp />
      </button>
    </div>
  );
};

export default ButtonScrollTop;
